module.exports = __webpack_public_path__ + "static/media/august-img.54ead0f2.jpg";